import React, { useEffect, useState } from "react";
import { Loader } from "../../components/loader/Loader";
import "./DeviationApproval.css";
import {
  TranslationEnum,
  usePortalTranslation,
} from "../../providers/TranslationProvider";
import DefaultHeading from "../../components/heading/DefaultHeading";
import NoDataMessage from "../../components/manageEvents/NoEventsMessage";
import { InfoOutlined } from "@material-ui/icons";
import {  PjpPlanConfig, getDeviationData, transformDeviationDayCard} from "./DeviationApprovalService"
import { DeviationDayCardType } from "./DeviationApprovalTypes";
import DeviationDayCard from "../../components/deviationApproval/deviationDayCard";

function DeviationApproval() {
  const { translate } = usePortalTranslation();
  const [showLoader, setShowLoader] = useState<boolean>(true);
  const [pjpPlanOption, setPjpPlanOption] = useState<any>(null);
  const [deviationData,setDeviationData] = useState<Record<string , any > []>([]);
  const [deviationDayCardData, setDeviationDayCardData] = useState<any>([]);

  useEffect(() => {
    const fetchPjpPlanConfig = async () => {
      try {
        const config = await PjpPlanConfig();
        setPjpPlanOption(config);
      } catch (error) {
        console.error("Error fetching PjpPlanConfig:", error);
      }
    };

    fetchPjpPlanConfig();
  }, []);

  const fetchDeviationData = async () => {
    try {
      setShowLoader(true);
      const PjpData = await getDeviationData(pjpPlanOption);
      setDeviationData(PjpData);

      const dayData : DeviationDayCardType[] = transformDeviationDayCard(PjpData, pjpPlanOption);
      setDeviationDayCardData(dayData);

    } catch (error) {
      console.error("Error fetching Deviation data:", error);
    } finally {
      setShowLoader(false);
    }
  };


  useEffect(() => {
    if (!pjpPlanOption) return;

    fetchDeviationData();
  }, [pjpPlanOption]);


  
  return (
    <div className="deviation-approval-parent">
      <DefaultHeading
        heading={translate(TranslationEnum.deviation_approval, "Deviation Approval")}
        showDefaultBackButton={true}
      />

        {showLoader ? (
            <div className="loader-center">
              <Loader />
            </div>
          ) : deviationData.length === 0 ? (
            <div className="loader-center">
              <NoDataMessage icon={<InfoOutlined />} message={translate(TranslationEnum.pjp_approval, "No data available.")} />
            </div>
          )
          : (

            <div className="dev-card-container">
            {deviationDayCardData?.map((data: DeviationDayCardType, index : number) => (
              <DeviationDayCard key={index} PjpDayData={data} pjpPlanOption={pjpPlanOption} fetchDeviationData={fetchDeviationData}/>
            ))}
          </div>

          )
        }
      
    </div>
  );
}

export default DeviationApproval;
